import React, { memo } from "react";
import { Image, TouchableOpacity, Animated, View } from "react-native";
import { SvgUri, SvgXml } from "react-native-svg";
import { emojis, getEmoji } from "./EmojiData";
import SvgView from "../../../cards/SvgView";

import { withErrorBoundary } from "react-error-boundary";

import APP_CONFIG from "../../../config/AppConfig";

import { trackClick, isWeb } from "../../../helpers/utils";

function ImageComponent(props) {
  const {
    styles,
    icon,
    image,
    action,
    onPress,
    onLongPress,
  } = props;
  const propStyle = styles || props.style;

  const itemIcon = !image && !icon ? "1f3f7-fe0f" : icon;
  const imageAction = action || onPress || onLongPress;
  const Tag = imageAction ? TouchableOpacity : View;

  const handleOnPress = () => {
    if (typeof imageAction === "function") imageAction();

    trackClick("icon image");
  };

  let hasIcon = itemIcon && itemIcon.length > 0 && itemIcon !== "null";
  let iconSvg = hasIcon && !isWeb ? getEmoji(itemIcon.toLowerCase()) : null;
  const iconUrl = `${APP_CONFIG.API_URL}/emoji?${itemIcon}`;

  const useView = false; //itemIcon === "mana"; //special rendering needed on web for svgs with image inside
  const localRender = iconSvg != null; //fallback to server if image not found locally
  if (!isWeb && iconSvg == null) hasIcon = false;

  return (
    <Tag
      onPress={handleOnPress}
      onLongPress={onLongPress}
      style={[{ maxWidth: "100%" }]}
    >
      {image ? (
        isWeb || !("" + image).startsWith("http") ? (
          <Animated.Image style={propStyle} source={image} />
        ) : (
          <Image style={propStyle} source={{ uri: "" + image }} />
        )
      ) : null}

      <>
        {hasIcon ? (
          isWeb ? (
            useView ? (
              <SvgView
                style={propStyle}
                uri={iconUrl}
                onPress={handleOnPress}
              />
            ) : (
              <Animated.Image
                style={propStyle}
                source={{ uri: `${APP_CONFIG.API_URL}/emoji?${itemIcon}` }}
              />
            )
          ) : localRender ? (
            <SvgXml style={propStyle} xml={iconSvg} />
          ) : (
            <SvgUri style={propStyle} uri={iconUrl} />
          )
        ) : null}
      </>
    </Tag>
  );
}

export default withErrorBoundary(memo(ImageComponent));
